import { createApiStore } from "./genericStore";
import { StockRoll, StockRollTransaction } from "../types/stockRoll";

// Kumaş Topları Store'u (Liste, Barkod Arama, Düzeltme İşlemleri İçin)
export const useStockRollStore = createApiStore<StockRoll>("/stockRoll");

// Kumaş Topu İşlem Geçmişi Store'u (Raporlama ve Detay Gösterimi İçin)
export const useStockRollTransactionStore = createApiStore<StockRollTransaction>("/stockRollTransaction");
